module.exports = __webpack_public_path__ + "static/media/big-neon-gif-6.209d8fef.gif";